export default __webpack_public_path__ + "media/images/react_icons/logo-sm-bg-dark-a296c1bacec4939f632b779f316652f2.svg";